export default "__VITE_ASSET__CM7H5OIV__"